import React, {Component} from "react";
import {InvoiceService} from "../../../../service/admin/invoice/InvoiceService";
import EditAddressView from "./EditAddressView";
import {EDIT_INSTITUTION_ROUTE} from "../../../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";
import {ADDRESS_BY_ACCOUNT, ADDRESS_BY_INSTITUTION} from "../../../../utils/constants/Constants";
import {isValidData} from "../../../../utils/validator/Fields";

export default class EditAddressContainer extends Component {
    constructor(props) {
        super(props);

        this.invoiceService = new InvoiceService();
        this.loading = this.loading.bind(this);
        this.returnEditInstitution = this.returnEditInstitution.bind(this);
        this.returnButton = this.returnButton.bind(this);
        this.getInstitutionAccounts = this.getInstitutionAccounts.bind(this);
        this.saveAddress = this.saveAddress.bind(this);
        this.saveTemporalList = this.saveTemporalList.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
        this.initData = this.initData.bind(this);

        this.state = {
            isLoading: false,
            accountsList: [],
            nAccounts: 0,
            institutionAddresses: this.props.location.state.institutionAddresses,
            institutionData: this.props.location.state.institutionData,
            isNewAddress: this.props.location.state.newAddress,
            addressData: {
                accountObj: '',
                sameAddress: false,
                Dir: '',
                Colonia: '',
                Cd: '',
                CP: '',
                RFC: '',
            },
            requiredFields: ['Dir', 'Colonia', 'Cd', 'CP', 'RFC'],
        };
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }
    componentDidMount() {
        if(this.props.location.state.institutionData.IdTipo === ADDRESS_BY_ACCOUNT){
            let requiredFieldsAux = this.state.requiredFields;
            requiredFieldsAux.push('accountObj');
            this.getInstitutionAccounts();
            this.setState({
                requiredFields: requiredFieldsAux,
            });
        }
        this.initData(this.props.location.state.newAddress);
    }

    initData(isNewAddress){
        let addressDataAux = this.state.addressData;
        if (!isNewAddress) {
            addressDataAux = this.props.location.state.addressData;
            addressDataAux['sameAddress'] = false;
        }
        this.setState({
            addressData: addressDataAux,
        });
    }

    returnEditInstitution(message, instAddresses) {
        this.props.history.push({
            pathname: EDIT_INSTITUTION_ROUTE,
            message: message,
            state: {
                selectedInstitution: this.state.institutionData,
                institutionAddresses: instAddresses,
                nAccounts: this.state.nAccounts,
            }
        });
    }

    getInstitutionAccounts() {
        let isNewAddress = this.props.location.state.newAddress;
        let account = !isNewAddress ? this.props.location.state.addressData['Cuenta'] : '';
        this.loading(true);
        this.invoiceService.getInstitutionAccounts(
            this.state.institutionData.IdInstitucion
        ).then(response => {
            let accountListAux = response.payload;
            let addressDataAux = this.state.addressData;
            addressDataAux['accountObj'] =  !isNewAddress ?
                response.payload.find((item) => item['Cuenta'] === account): '';
            if(isNewAddress){
                this.state.institutionAddresses.forEach((item) => {
                    accountListAux = accountListAux.filter((val) =>
                        val['Cuenta'] !== item['Cuenta']
                    );
                });
            }

            this.setState({
                accountsList: accountListAux,
                addressData: addressDataAux,
                nAccounts: response.payload.length,
            });
            this.loading(false);
        });
    }

    onChangeValue(event) {
        const{name, value} = event.target;
        let addressDataAux = this.state.addressData;
        addressDataAux[name] = name === "sameAddress" ?
            event.checked : value;
        if(name === 'accountObj'){
            addressDataAux['Cuenta'] = value['Cuenta'];
        }
        this.setState({
            addressData: addressDataAux,
        });
    }

    saveAddress(){
        if (!isValidData(this.state.requiredFields, this.state.addressData)) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Debe llenar los campos requeridos correctamente'
            });
        } else {
            if((this.state.institutionData.IdTipo === ADDRESS_BY_INSTITUTION) ||
                (this.state.addressData.sameAddress)){
                this.invoiceService.updateInstitutionAddress(
                    this.state.institutionData, [this.state.addressData],
                    this.state.addressData.sameAddress)
                    .then(res => {
                        if(res.message === "Success"){
                            let message = {};
                            message['severity'] = 'success';
                            message['summary'] = 'Éxito.';
                            message['detail'] = 'Se ha actualizado correctamente su solicitud.';
                            this.returnEditInstitution(message);
                        }else{
                            this.growl.show({severity: 'error', summary: 'Error.',
                                detail: res.error});
                        }
                    });
            }else{
                this.saveTemporalList();
            }
        }
    }

    saveTemporalList(){
        let instAddressList = this.state.institutionAddresses;
        if (!this.state.isNewAddress){
            instAddressList = instAddressList.filter((item) =>
                item['Cuenta'] !== this.state.addressData['cuenta']);
        }
        instAddressList.push(this.state.addressData);
        this.setState({institutionAddresses: instAddressList});
        if(this.state.institutionAddresses.length === this.state.nAccounts){
            this.invoiceService.updateInstitutionAddress(
                this.state.institutionData, this.state.institutionAddresses, false)
                .then(res => {
                    if(res.message === "Success"){
                        this.returnEditInstitution({
                            severity: 'success',
                            summary: 'Éxito.',
                            detail: 'Se ha actualizado correctamente su solicitud.'
                        });
                    }else{
                        this.growl.show({severity: 'error', summary: 'Error.',
                            detail: res.error});
                    }
                });
        }else{
            this.returnEditInstitution({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Se ha agregado correctamente la dirección.',
            }, this.state.institutionAddresses);
        }
    }
    returnButton(){
        this.returnEditInstitution('', this.state.institutionAddresses);
    }


    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        let {isLoading, institutionData, addressData, isNewAddress,
            accountsList} = this.state;
        return <EditAddressView
            isLoading={isLoading}
            institutionData={institutionData}
            addressData={addressData}
            isNewAddress = {isNewAddress}
            accountsList={accountsList}
            messagesGrowl={messagesGrowl}
            returnButton={this.returnButton}
            onChangeValue={this.onChangeValue}
            saveAddress={this.saveAddress}
            loading={this.loading}
        />
    }
};
